import posthog from 'posthog-js';

const NO_AUTH_PAGES = ['/signin', '/unsubscribe'];

function identifyUser(sessionData: { userId: number; email: string }) {
    posthog.identify(`${sessionData.userId}`, {
        email: sessionData.email,
    });
}

export default defineNuxtRouteMiddleware(async (to) => {
    if (NO_AUTH_PAGES.some(url => to.path.includes(url))) return;

    const [sessionData, refreshSession] = useSessionData();

    // If session data already exists, navigate immediately and refresh in background.
    // This avoids blocking every page transition on a network round-trip — the main
    // cause of sluggish navigation when the previous page had heavy polling.
    if (sessionData.value) {
        identifyUser(sessionData.value);
        refreshSession().catch(async (error: unknown) => {
            const status = (error as { statusCode?: number })?.statusCode;
            if (status === 401) {
                await $fetch('/api/auth/session', { method: 'DELETE' }).catch(() => {});
                navigateTo('/signin');
            }
        });
        return;
    }

    // No session data yet (first load) — must await to verify auth before rendering
    try {
        await refreshSession();
        if (sessionData.value) {
            identifyUser(sessionData.value);
        }
    } catch (error: unknown) {
        const status = (error as { statusCode?: number })?.statusCode;
        if (status === 401) {
            await $fetch('/api/auth/session', { method: 'DELETE' }).catch(() => {});
            return navigateTo('/signin');
        }
    }
})
